import { defineComponent as Ie, toRef as Se, ref as w, computed as z, onMounted as Ce, useSlots as be, watch as x, openBlock as n, createElementBlock as h, normalizeClass as V, createVNode as q, unref as c, mergeProps as ce, withKeys as T, withModifiers as v, withCtx as G, createBlock as L, toDisplayString as R, createCommentVNode as k, renderSlot as H, createElementVNode as M, Transition as Ve, withDirectives as Te, Fragment as Be, renderList as Le, vShow as Ae } from "vue";
import Pe from "../Checkbox/Checkbox.esm.js";
import { _ as O } from "../Icon.vue_vue_type_script_setup_true_lang-BMhFqNxf.js";
import de from "../TextField/TextField.esm.js";
import { _ as Ee } from "../_plugin-vue_export-helper-CHgC5LLL.js";
import '../Select.css';const Me = {
  key: 0,
  class: "flex flex-1 items-center gap-1 mr-2"
}, Oe = ["src", "alt"], Fe = {
  key: 2,
  class: "w-max"
}, $e = {
  key: 0,
  class: "flex gap-1"
}, ze = ["aria-selected", "onClick", "onKeydown", "name"], De = { key: 1 }, Ke = { key: 2 }, Ne = ["src", "alt"], Re = { class: "flex flex-col flex-1" }, Ue = /* @__PURE__ */ Ie({
  __name: "Select",
  props: {
    size: { default: "medium" },
    options: { default: () => [] },
    iconPlacement: { default: "left" },
    label: { default: "" },
    placeholder: { default: "" },
    modelValue: { default: "" },
    multiple: { type: Boolean },
    error: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    id: { default: "" },
    helperText: { default: "" },
    trailingIcon: { default: "" },
    trailingImage: { default: "" },
    endIcon: { default: "" },
    classes: { default: () => ({}) },
    inputClasses: { default: () => ({}) },
    toolTipIcon: { default: "information-circle-icon" },
    showToolTipIcon: { type: Boolean, default: !1 },
    allowFilter: { type: Boolean, default: !1 },
    inputProps: { default: () => ({}) },
    filterProps: { default: () => ({}) },
    filterPlaceholder: { default: "Search..." },
    showClearAllIcon: { type: Boolean, default: !1 },
    showSelectAllIcon: { type: Boolean, default: !1 },
    customFilter: { type: Function, default: () => [] },
    fixedPlaceholder: { default: "" },
    showCheckBox: { type: Boolean, default: !1 },
    disableDeselect: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "onTrailingIconClick", "onEndIconClick", "onTooltipClick", "onSelect"],
  setup(pe, { emit: ve }) {
    const l = pe, s = ve, B = Se(l, "modelValue"), m = w(!1), g = w(""), d = w([]), f = w([]), I = w([]), u = w(-1), y = w([]), S = w(-1), p = w(l.options), U = w(null), D = w(""), A = z(() => new Set(d.value)), K = z(() => new Set(y.value)), N = z(() => new Set(f.value)), P = z(() => new Set(I.value)), J = (e) => {
      var a;
      !l.multiple && typeof B.value == "string" && (g.value = ((a = l.options.find((t) => t.value.toLowerCase() === B.value.toLowerCase())) == null ? void 0 : a.name) || "", S.value = l.options.findIndex(
        (t) => t.value.toLowerCase() === B.value.toLowerCase()
      )), Array.isArray(B.value) && l.multiple && (e && (d.value = [], I.value = [], f.value = []), y.value = l.options.map((t, i) => Array.isArray(B.value) && B.value.find((o) => o.toLowerCase().includes(t.value.toLowerCase())) ? (d.value.push(t.name), I.value.push(t), f.value.push(t.value), i) : -1));
    };
    Ce(() => J());
    function F() {
      l.disabled || (m.value = !m.value, s("onEndIconClick", m.value));
    }
    const Q = () => {
      m.value = !1, u.value = -1, S.value = -1;
    }, me = (e, a) => {
      const { name: t, value: i } = e;
      A.value.has(t) ? (A.value.delete(t), K.value.delete(a), N.value.delete(i), P.value.forEach((o) => {
        o.name === t && P.value.delete(o);
      }), d.value = [...A.value], y.value = [...K.value], f.value = [...N.value], I.value = [...P.value]) : (d.value.push(e.name), f.value.push(e.value), y.value.push(a), I.value.push(e)), s("onSelect", I.value), s("update:modelValue", f.value);
    }, fe = (e, a) => {
      l.disableDeselect || g.value.toLowerCase() !== e.name.toLowerCase() ? (g.value = e.name, S.value = a, s("onSelect", e), s("update:modelValue", e.value)) : (g.value = "", S.value = -1, s("onSelect", ""), s("update:modelValue", ""));
    };
    function W(e, a) {
      l.multiple ? me(e, a) : (fe(e, a), m.value = !1), u.value = -1;
    }
    function X() {
      const e = document.getElementById("menu-container");
      if (!e) return;
      const { top: a, bottom: t } = e.getBoundingClientRect(), i = e.children[u.value];
      if (!i) return;
      const { top: o, bottom: C } = i.getBoundingClientRect();
      o < a ? e.scrollTop -= a - o : C > t && (e.scrollTop += C - t);
    }
    function Y() {
      m.value = !0, u.value < p.value.length - 1 && (u.value += 1), X();
    }
    function Z() {
      m.value = !0, u.value > 0 && (u.value -= 1), X();
    }
    const he = () => {
      const e = p.value[u.value], { name: a, value: t } = e;
      A.value.has(a) ? (A.value.delete(a), K.value.delete(u.value), N.value.delete(t), P.value.forEach((i) => {
        i.name === t && P.value.delete(i);
      }), d.value = [...A.value], y.value = [...K.value], f.value = [...N.value], I.value = [...P.value]) : (d.value.push(a), f.value.push(t), I.value.push(e), y.value.push(u.value)), s("onSelect", I.value), s("update:modelValue", f.value);
    }, ge = () => {
      const e = p.value[u.value];
      if (l.disableDeselect || g.value.toLowerCase() !== e.name.toLowerCase()) {
        g.value = e.name;
        const a = u.value;
        S.value = a, u.value = a, s("onSelect", e), s("update:modelValue", e.value);
      } else
        g.value = "", S.value = -1, s("onSelect", ""), s("update:modelValue", "");
    };
    function _() {
      u.value !== -1 && (l.multiple ? he() : (ge(), m.value = !1));
    }
    function ye() {
      D.value !== "" ? p.value = (l == null ? void 0 : l.customFilter(l.options).length) > 0 ? l == null ? void 0 : l.customFilter(l.options) : l.options.filter((e) => e.name.toLowerCase().includes(D.value.toLowerCase())) : p.value = l.options;
    }
    const E = be(), j = z(() => l.multiple ? d.value.length > 3 ? `${d.value.slice(0, 3).join(", ")}, +${d.value.length - 3}...` : d.value.join(", ") : g.value), we = () => {
      l.multiple ? (d.value.length = 0, y.value.length = 0, f.value.length = 0, I.value.length = 0) : (g.value = "", S.value = -1), u.value = -1, m.value = !1, p.value = l.options, s("onSelect", l.multiple ? [] : ""), s("update:modelValue", l.multiple ? [] : "");
    }, ke = () => {
      const e = [], a = [], t = [];
      p.value.forEach((i, o) => {
        e.push(i.name), a.push(o), t.push(i.value);
      }), d.value = e, y.value = a, f.value = t, u.value = -1, s("onSelect", p.value), s("update:modelValue", f.value);
    }, ee = (e) => {
      (e.target.tagName.toLowerCase() === "label" || U.value && !U.value.contains(e.target)) && (m.value = !1);
    };
    return x(
      () => m.value,
      (e) => {
        e ? document.addEventListener("click", ee) : document.removeEventListener("click", ee);
      }
    ), x(
      () => B.value,
      () => {
        J(!0);
      }
    ), x(
      () => l.options,
      () => {
        p.value = l.options;
      }
    ), (e, a) => {
      var t, i;
      return n(), h("div", {
        ref_key: "torusSelect",
        ref: U,
        class: V(["relative inline-block w-full", (t = e.classes) == null ? void 0 : t.container])
      }, [
        q(c(de), ce({
          id: e.id,
          modelValue: j.value,
          "onUpdate:modelValue": a[1] || (a[1] = (o) => j.value = o),
          "aria-labelledby": e.label,
          label: e.label,
          disabled: e.disabled,
          size: e.size,
          placeholder: e.placeholder,
          error: e.error,
          success: e.success,
          "show-tool-tip-icon": e.showToolTipIcon,
          classes: {
            endIcon: `${e.disabled ? "!text-app-gray-400 !cursor-not-allowed" : ""}`,
            inputContainer: "cursor-pointer",
            input: "cursor-pointer",
            ...e.inputClasses
          },
          "selected-option": g.value
        }, { ...e.inputProps, helperText: "", class: "", isSelect: !0, click: F, readonly: !0 }, {
          onOnTooltipClick: a[2] || (a[2] = (o) => s("onTooltipClick")),
          onKeydown: [
            T(v(F, ["exact", "stop", "prevent"]), ["space"]),
            T(v(Q, ["exact"]), ["esc"]),
            T(v(Y, ["exact", "stop"]), ["arrow-down"]),
            T(v(Z, ["exact", "stop"]), ["arrow-up"]),
            T(v(_, ["exact", "stop"]), ["enter"])
          ],
          onClick: F
        }), {
          trailingIconSlot: G(() => {
            var o;
            return [
              !((o = c(E)) != null && o.trailingIconSlot) && (e.trailingIcon || e.trailingImage || e.fixedPlaceholder) ? (n(), h("div", Me, [
                e.trailingImage ? (n(), h("img", {
                  key: 0,
                  src: e.trailingImage,
                  alt: j.value,
                  class: "h-7 w-auto"
                }, null, 8, Oe)) : e.trailingIcon ? (n(), L(c(O), {
                  key: 1,
                  name: e.trailingIcon,
                  onClick: a[0] || (a[0] = v((C) => s("onTrailingIconClick"), ["stop"]))
                }, null, 8, ["name"])) : e.fixedPlaceholder ? (n(), h("p", Fe, R(e.fixedPlaceholder), 1)) : k("", !0)
              ])) : H(e.$slots, "trailingIconSlot", { key: 1 }, void 0, !0)
            ];
          }),
          endIconSlot: G(() => {
            var o, C, $;
            return [
              (o = c(E)) != null && o.endIconSlot ? H(e.$slots, "endIconSlot", { key: 1 }, void 0, !0) : (n(), h("div", $e, [
                M("span", {
                  "aria-hidden": "",
                  title: "Clear All Selected Items",
                  onClick: v(we, ["stop"])
                }, [
                  e.showClearAllIcon && ((C = c(E)) != null && C.options ? l.modelValue : g.value || d.value.length > 0) ? (n(), L(c(O), {
                    key: 0,
                    name: "x-circle-solid-icon",
                    class: "cursor-pointer"
                  })) : k("", !0)
                ]),
                M("span", {
                  "aria-hidden": "",
                  title: "Select All Selected Items",
                  onClick: v(ke, ["stop"])
                }, [
                  e.multiple && e.showSelectAllIcon && !(($ = c(E)) != null && $.options) ? (n(), L(c(O), {
                    key: 0,
                    name: "check-circle-solid-icon",
                    class: "cursor-pointer"
                  })) : k("", !0)
                ]),
                e.endIcon ? (n(), L(c(O), {
                  key: 0,
                  name: e.endIcon,
                  onClick: v(F, ["stop"])
                }, null, 8, ["name"])) : (n(), L(c(O), {
                  key: 1,
                  name: m.value ? "chevron-up-solid-icon" : "chevron-down-solid-icon",
                  onClick: v(F, ["stop"])
                }, null, 8, ["name"]))
              ]))
            ];
          }),
          _: 3
        }, 16, ["id", "modelValue", "aria-labelledby", "label", "disabled", "size", "placeholder", "error", "success", "show-tool-tip-icon", "classes", "selected-option", "onKeydown"]),
        q(Ve, { name: "select-fade" }, {
          default: G(() => {
            var o, C, $, le, ae;
            return [
              Te(M("div", {
                class: V([
                  "z-10 absolute overflow-hidden p-1 mt-2 left-0 w-full h-auto border border-app-gray-200 rounded-md bg-app-white shadow-xl text-app-gray-900 dark:bg-app-gray-700 dark:border-app-gray-600 dark:text-app-white",
                  "transition duration-300 ease-in-out origin-top",
                  (o = e.classes) == null ? void 0 : o.optionContainer
                ])
              }, [
                e.allowFilter ? (n(), L(c(de), ce({
                  key: 0,
                  modelValue: D.value,
                  "onUpdate:modelValue": a[3] || (a[3] = (r) => D.value = r),
                  "aria-labelledby": "filter",
                  size: "small",
                  placeholder: e.filterPlaceholder,
                  class: ["mb-4", (C = e.classes) == null ? void 0 : C.multipleFilter]
                }, e.filterProps, {
                  onInput: ye,
                  onKeydown: [
                    T(v(Y, ["exact", "stop"]), ["arrow-down"]),
                    T(v(Z, ["exact", "stop"]), ["arrow-up"]),
                    T(v(_, ["exact", "stop"]), ["enter"])
                  ]
                }), null, 16, ["modelValue", "placeholder", "class", "onKeydown"])) : k("", !0),
                !(($ = c(E)) != null && $.options) && p.value && p.value.length > 0 ? (n(), h("div", {
                  key: 1,
                  id: "menu-container",
                  class: V(["max-h-[215px] overflow-y-auto", (le = e.classes) == null ? void 0 : le.itemContainer])
                }, [
                  (n(!0), h(Be, null, Le(p.value, (r, b) => {
                    var te, oe, se, ne, ue, ie, re;
                    return n(), h("div", {
                      key: r.name,
                      class: V([
                        "flex items-center gap-4 px-4 py-2 cursor-pointer hover:bg-app-gray-300 text-app-gray-900 dark:text-app-white dark:hover:bg-app-gray-600 rounded-lg",
                        {
                          "!bg-app-gray-300 dark:!bg-app-gray-600": u.value === b,
                          "flex-row": e.iconPlacement === "left",
                          "flex-row-reverse": e.iconPlacement === "right",
                          "mb-2": b !== p.value.length - 1
                        },
                        l.multiple && y.value.includes(b) && (((te = e.classes) == null ? void 0 : te.activeItem) || "!text-app-primary-600 dark:!text-app-white dark:!bg-app-gray-500 !bg-app-gray-100"),
                        !l.multiple && S.value === b && (((oe = e.classes) == null ? void 0 : oe.activeItem) || "!text-app-primary-600 dark:!text-app-white dark:!bg-app-gray-500 !bg-app-gray-100"),
                        (se = e.classes) == null ? void 0 : se.option
                      ]),
                      "aria-hidden": "",
                      "aria-selected": e.multiple ? y.value.includes(b) : S.value === b,
                      role: "option",
                      onClick: (je) => W(r, b),
                      onKeydown: T(v(Q, ["exact"]), ["esc"]),
                      "data-testid": "select-option",
                      name: r.name
                    }, [
                      e.showCheckBox ? (n(), L(c(Pe), {
                        key: 0,
                        id: r.name,
                        value: r.name,
                        checked: e.multiple ? y.value.includes(b) : S.value === b
                      }, null, 8, ["id", "value", "checked"])) : k("", !0),
                      r.icon ? (n(), h("div", De, [
                        q(c(O), {
                          name: r.icon,
                          size: "20",
                          class: V(["w-5", ((ne = e.classes) == null ? void 0 : ne.optionIcon) || ""])
                        }, null, 8, ["name", "class"])
                      ])) : k("", !0),
                      r.imgSrc ? (n(), h("div", Ke, [
                        M("img", {
                          src: r.imgSrc,
                          alt: r.name,
                          class: V(["w-7 h-5", (ue = e.classes) == null ? void 0 : ue.optionImg])
                        }, null, 10, Ne)
                      ])) : k("", !0),
                      M("div", Re, [
                        M("span", {
                          class: V(["text-base font-normal", (ie = e.classes) == null ? void 0 : ie.optionName])
                        }, R(r.name), 3),
                        r.description ? (n(), h("span", {
                          key: 0,
                          class: V(["text-xs font-normal text-app-gray-500 dark:text-app-gray-300", (re = e.classes) == null ? void 0 : re.optionDesc]),
                          "data-testid": "select-option-description"
                        }, R(r.description), 3)) : k("", !0)
                      ])
                    ], 42, ze);
                  }), 128))
                ], 2)) : k("", !0),
                (ae = c(E)) != null && ae.options ? H(e.$slots, "options", {
                  key: 2,
                  selectOption: W,
                  options: p.value
                }, void 0, !0) : k("", !0)
              ], 2), [
                [Ae, m.value]
              ])
            ];
          }),
          _: 3
        }),
        e.helperText ? (n(), h("p", {
          key: 0,
          class: V([
            "text-xs font-normal mt-1",
            e.success && !e.disabled ? "success-msg" : e.error && !e.disabled ? "error-msg" : "default-msg",
            (i = e.classes) == null ? void 0 : i.helperText
          ]),
          "data-testid": "helper-text"
        }, R(e.helperText), 3)) : k("", !0)
      ], 2);
    };
  }
}), Qe = /* @__PURE__ */ Ee(Ue, [["__scopeId", "data-v-043a3b5e"]]);
export {
  Qe as default
};
//# sourceMappingURL=Select.esm.js.map
